import {FormTypePipe} from "../pipes/form-type.pipe";
import {AbstractControl, FormArray} from "@angular/forms";
import * as adDocDef from "../form-answers-json/ad.json";
import * as polstDocDef from "../form-answers-json/polst.json";
import {PatientSearchUtil} from "./patient-search.util";
import {NotificationService} from "@progress/kendo-angular-notification";
import {ProcessAbbyyService} from "../../core/services/process-abbyy.service";
import {catchError, tap} from "rxjs/operators";
import {from, of} from "rxjs";
import {Injectable} from "@angular/core";
import {showNotification} from "./notificaton.util";

@Injectable({ providedIn: 'root' })
export class ProcessFormsUtil {
    constructor(public processFormService: ProcessAbbyyService, private notificationService: NotificationService) {}
    static dataEntryFormTypes = [
        {text: 'Advance Healthcare Directive', value: 'ahd'},
        {text: 'Healthcare POA', value: 'hcpoa'},
        {text: 'Living Will', value: 'living_will'},
        {text: 'Mental HC POA', value: 'mhcpoa'},
        {text: 'POLST', value: 'POLST'},
        {text: 'Prehospital Care Directive', value: 'prehospital'}
    ];
    static typePipe = new FormTypePipe();
    public static getDataEntryFormTypes(currentFormType: any): any[] {
        const currentFormTypeObject = {text: 'Original Type: ' + this.typePipe.transform(currentFormType), value: null};
        return [currentFormTypeObject, ...ProcessFormsUtil.dataEntryFormTypes];
    }
    public static isLLuPatient(mrn: any, formId: any) {
        return (mrn !== null && mrn !== undefined && mrn.length > 0 && formId === 102);
    }
  async publishPolstForm(abbyyFormId: string, patient: any, answers: any, status: string, nullify: boolean, language: string, onSuccess?: (ptForms: any) => void) {
    patient.is_iehp_patient = patient?.is_iehp_patient ?? false;
    try {
      const ptForms = await this.processFormService.publishForm(abbyyFormId, patient, answers, status, nullify, language);
      showNotification('POLST Published!', 'success', this.notificationService);
      if (onSuccess) {
        onSuccess(ptForms);
      }
      return ptForms;
    } catch (err) {
      console.error(err);
      const msg = err?.error?.message ?? 'An Error Occurred';
      showNotification(msg, 'error', this.notificationService);
      throw err;
    }
  }
  async rejectPolstForm(abbyyFormId: string, patient: any, rejectReasons: any, answers: any, nullify: boolean, language: string, onSuccess?: (ptForms: any) => void) {
    patient.is_iehp_patient = patient?.is_iehp_patient ?? false;
    try {
      const ptForms = await this.processFormService.rejectForm(abbyyFormId, patient, rejectReasons, answers, nullify, language);
      showNotification('POLST Rejected!', 'success', this.notificationService);
      if (onSuccess) {
        onSuccess(ptForms);
      }
      return ptForms;
    } catch (err) {
      console.error(err);
      const msg = err?.error?.message ?? 'An Error Occurred';
      showNotification(msg, 'error', this.notificationService);
      throw err;
    }
  }
  async processAdvanceDirectiveForm(abbyyFormId: any, patient: any, answers: any, status: string, formType: string, agentForm: any, mrn: string, rejectReasons: any,
                              nullify: boolean, isIehpPatient: boolean, lang: string, additionalForms: any, iehpHcpoa: any, onSuccess?: (ptForms: any) => void) {
    patient.is_iehp_patient = patient?.is_iehp_patient ?? false;
    try {
      const ptForms = await this.processFormService.processAd(abbyyFormId, patient, answers, status, formType, agentForm, mrn, rejectReasons, nullify,
        isIehpPatient, lang, additionalForms, iehpHcpoa);
      showNotification('Advance Directive Processed!', 'success', this.notificationService);
      if (onSuccess) {
        onSuccess(ptForms);
      }
      return ptForms;
    } catch (err) {
      console.error(err);
      const msg = err?.error?.message ?? 'An Error Occurred';
      showNotification(msg, 'error', this.notificationService);
      throw err;
    }
  }
    public static syncMultiplePairs(pairs: { source: AbstractControl | null; target: AbstractControl | null }[], twoWay: boolean = false): () => void {
        const subs: any[] = [];

        pairs.forEach(({ source, target }) => {
            if (!source || !target) return;

            // 🔁 Sync source → target
            const subA = source.valueChanges.subscribe(value => {
                if (target.value !== value) {
                    target.setValue(value, { emitEvent: false });
                }
            });
            subs.push(subA);

            // 🔁 Sync target → source (only if twoWay = true)
            if (twoWay) {
                const subB = target.valueChanges.subscribe(value => {
                    if (source.value !== value) {
                        source.setValue(value, { emitEvent: false });
                    }
                });
                subs.push(subB);
            }
        });

        // Return cleanup function to stop syncing
        return () => subs.forEach(s => s.unsubscribe());
    }
    public static getCurrentForms(ads: any, polsts: any) {
        let current = [];
        ads.forEach(a => {
            if (a.current) {
                current.push(a);
            }
        });
        polsts.forEach(p => {
            p.doc_date = p.created;
            if (p.current) {
                current.push(p);
            }
        });
        return current.sort((a, b) => {return +new Date(b.doc_date) - +new Date(a.doc_date);});
    }
    public static getNonCurrent(ads: any, polsts: any) {
        let nonCurrent = [];
        ads.forEach(a => {
            if (!a.current) {
                nonCurrent.push(a);
            }
        });
        polsts.forEach(p => {
            p.doc_date = p.created;
            if (!p.current) {
                nonCurrent.push(p);
            }
        });
        return nonCurrent.sort((a, b) => {return +new Date(b.doc_date) - +new Date(a.doc_date);});
    }
    public static hasPhysicianSigValue(requiredKeys: any) {
      if (requiredKeys.phys_sig !== undefined) {
        if (requiredKeys.phys_sig.value !== undefined) {
          return true;
        }
      }
      return false;
    }
    // UI styles helper
    public static getPercentageClass(value: number): string {
        let percent = value * 100;
        if (percent >= 80) return 'green';
        if (percent >= 50) return 'yellow';
        return 'red';
    }
    public static getStatusColor(status: any): string {
        let color = '';
        if (status === 'publish' || status == 'valid') {
            color = 'green';
        } else if (status === 'archive') {
            color = 'yellow';
        } else {
            color = 'red';
        }
        return color;
    }
    public static getStatus(value: string): string {
        if (value === 'published') {
            return 'green';
        } else {
            return 'red';
        }
    }
    public static cleanDataForProcessing(ptData: any): any {
        const patient = ptData;
        patient.state = ptData.state !== undefined && ptData.state !== null ?
            ptData.state.value : '';
        patient.gender = ptData.gender !== undefined && ptData.gender !== null ?
            ptData.gender.value : '';
        return patient;
    }

    public static syncPatientData(ptData: any): any {
         return  {
            id: ptData.id,
            zip: ptData.zip,
            fname: ptData.fname,
            lname: ptData.lname,
            suffix: ptData.suffix,
            city: ptData.city,
            dob: new Date(ptData.dob),
            state: {value: ptData.state},
            gender: {value: ptData.gender},
            street: ptData.street,
            phone: ptData.phone
        };
    }
    public static getFormColumnColor(form: any): string {
        let color = '';
        if (form.type === 'POLST') {
            color = "#ffcdd2";
        } else {
            color = "#ADD8E6";
        }
        return color;
    }

    public static setPolstJsonAnswers(polstAnswers: any, docDate: any, patient: any): any {
        const answers = [
            { id: 'patient_last_name', answer: PatientSearchUtil.cleanEmptyString(patient.fname), sub_field_answer: null},
            { id: 'patient_first_name', answer: PatientSearchUtil.cleanEmptyString(patient.lname), sub_field_answer: null },
            { id: 'patient_middle_name', answer: PatientSearchUtil.cleanEmptyString(patient.mname), sub_field_answer: null },
            { id: 'date_form_prepared', answer: docDate, sub_field_answer: null },
            { id: 'patient_dob', answer: PatientSearchUtil.cleanEmptyString(patient.dob), sub_field_answer: null },
            { id: 'medical_record_number', answer: PatientSearchUtil.cleanEmptyString(patient.mrn), sub_field_answer: null },
            { id: 'physician_signature', answer: polstAnswers.pt_sig, sub_field_answer: null },
            { id: 'patient_signature', answer: polstAnswers.phys_sig, sub_field_answer: null },
        ];
        return {answers: answers};
    }

    public static setAdJsonAnswers(adAnswers: any, docDate: any, patient: any): any {
        const answers = [
            { id: 'doc_date', answer: docDate, sub_field_answer: null},
            { id: 'patient_first_name', answer: PatientSearchUtil.cleanEmptyString(patient.fname), sub_field_answer: null },
            { id: 'patient_middle_name', answer: PatientSearchUtil.cleanEmptyString(patient.mname), sub_field_answer: null },
            { id: 'patient_last_name', answer: PatientSearchUtil.cleanEmptyString(patient.lname), sub_field_answer: null },
            { id: 'patient_dob', answer: PatientSearchUtil.cleanEmptyString(patient.dob), sub_field_answer: null },
            { id: 'principal_signature', answer: adAnswers.principal_sig, sub_field_answer: null },
            { id: 'agent_fname', answer: adAnswers.agent_fname, sub_field_answer: null },
            { id: 'agent_lname', answer: adAnswers.agent_lname, sub_field_answer: null },
            { id: 'agent_phone', answer: adAnswers.agent_phone, sub_field_answer: null },
            { id: 'alt_agent_fname', answer: adAnswers.alt_fname, sub_field_answer: null },
            { id: 'alt_agent_lname', answer: adAnswers.alt_lname, sub_field_answer: null },
            { id: 'alt_agent_phone', answer: adAnswers.alt_phone, sub_field_answer: null },
            { id: 'witness_1_signature', answer: adAnswers.wit_1_sig == null || adAnswers.wit_1_sig == undefined ? false : adAnswers.wit_1_sig, sub_field_answer: null },
            { id: 'witness_2_signature', answer: adAnswers.wit_2_sig == null || adAnswers.wit_2_sig == undefined ? false : adAnswers.wit_2_sig, sub_field_answer: null },
            { id: 'notary_signature', answer: adAnswers.notary_sig, sub_field_answer: null },
        ];
        return {answers: answers};
    }

    // PDF VIEWER UTILS
    public static getDivElement(boundingRegions: any, currentZoom: any): HTMLDivElement {
        const rectElem = ProcessFormsUtil.getRectangleObject(boundingRegions, currentZoom);
        // Create overlay div
        const highlight = document.createElement('div');
        highlight.classList.add('highlight-box');
        highlight.style.position = 'absolute';
        // highlight.style.backgroundColor = 'yellow';
        // border
        highlight.style.border = '2px solid red';
        highlight.style.borderRadius = '4px'; // optional rounded corners
        highlight.style.opacity = '0.4';
        highlight.style.zIndex = '35';
        highlight.style.left = rectElem.rect.x1 + 'px';
        highlight.style.top = rectElem.rect.y1 + 'px';
        highlight.style.width = rectElem.rect.width + 'px';
        highlight.style.height = rectElem.rect.height + 'px';
        highlight.style.cursor = 'pointer';
        return highlight;
    }
    public static getRectangleObject(boundingRegions: any, currentZoom: any): any {
        const pageNumber = boundingRegions.pageNumber;
        const boundingBox = boundingRegions.polygon !== undefined ? boundingRegions.polygon : boundingRegions.boundingPolygon;
        // get coordinates needed to draw the rectangle and convert inches to pixels using PPI = 96
        const x1 = ProcessFormsUtil.inchesToPixels(boundingBox[0]) * currentZoom;
        const y1 = ProcessFormsUtil.inchesToPixels(boundingBox[1]) * currentZoom;
        const x2 = ProcessFormsUtil.inchesToPixels(boundingBox[2]) * currentZoom;
        const y2 = ProcessFormsUtil.inchesToPixels(boundingBox[3]) * currentZoom;
        const x3 = ProcessFormsUtil.inchesToPixels(boundingBox[4]) * currentZoom;
        const y3 = ProcessFormsUtil.inchesToPixels(boundingBox[5]) * currentZoom;
        const x4 = ProcessFormsUtil.inchesToPixels(boundingBox[6]) * currentZoom;
        const y4 = ProcessFormsUtil.inchesToPixels(boundingBox[7]) * currentZoom;
        const height = Math.abs(y1 - y3);
        const width = Math.abs(x3 - x1);
        return {
            rectangleId: 'rectangle-1',
            pageNumber,
            rect: {
                height,
                width,
                x1,
                y1,
                x2,
                y2
            }
        };
    }
    public static inchesToPixels(inch: any): any {
        const multiplier = Math.pow(10, 0);
        return Math.round((inch * 96) * multiplier / multiplier);
        // changed PPI from 96 to 72 for PDFTron
    }
    public static getTopY(box: any): number {
        // extract only Y values (indices 1, 3, 5, 7)
        const yValues = box.boundingPolygon.filter((_, i) => i % 2 !== 0);
        return Math.min(...yValues);
    }
}
